// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3ecPo","unreadBadge":"styles_unreadBadge__uV2KP","modalContent":"styles_modalContent__1xQV_","modal":"styles_modal__3v-0Z"};